/* ==========================================================================
   Mi Jardín — theme.js
   Vanilla JS, sin dependencias. Mejora progresiva.
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || {};
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* -------------------------------------------------- Utilidades dinero */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = format || theme.moneyFormat || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(num, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      default: value = defaultTo(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  /* -------------------------------------------------- Toast */
  var toastTimer;
  function showToast(message) {
    var el = $('#toast');
    if (!el) return;
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg><span>' + message + '</span>';
    el.classList.add('is-visible');
    el.setAttribute('aria-hidden', 'false');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      el.setAttribute('aria-hidden', 'true');
    }, 3200);
  }

  /* -------------------------------------------------- Revelado al hacer scroll */
  function initReveals() {
    var els = $$('[data-reveal]');
    if (!els.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* -------------------------------------------------- Cabecera reactiva */
  function initHeader() {
    var wrap = $('.header-wrap');
    if (!wrap) return;

    var onScroll = function () {
      if (window.scrollY > 40) wrap.classList.add('is-scrolled');
      else wrap.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Mide la altura real de la cabecera flotante para el solape del héroe
    function setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', wrap.offsetHeight + 'px');
    }
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight, { passive: true });
    window.addEventListener('load', setHeaderHeight);
  }

  /* -------------------------------------------------- Indicador de nav deslizante */
  function initNavIndicator() {
    var nav = $('[data-nav]');
    if (!nav) return;
    var indicator = $('[data-nav-indicator]', nav);
    var items = $$('[data-nav-item]', nav);
    if (!indicator || !items.length) return;
    var active = nav.querySelector('.header__nav-link.is-active');

    function moveTo(el) {
      if (!el) { indicator.classList.remove('is-ready'); return; }
      var navRect = nav.getBoundingClientRect();
      var rect = el.getBoundingClientRect();
      indicator.style.width = rect.width + 'px';
      indicator.style.transform = 'translateX(' + (rect.left - navRect.left) + 'px)';
      indicator.classList.add('is-ready');
    }
    function rest() { active ? moveTo(active) : indicator.classList.remove('is-ready'); }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { moveTo(item); });
      item.addEventListener('focus', function () { moveTo(item); });
    });
    nav.addEventListener('mouseleave', rest);
    nav.addEventListener('focusout', function (e) {
      if (!nav.contains(e.relatedTarget)) rest();
    });
    // Posición inicial (tras asentarse la tipografía)
    rest();
    window.addEventListener('load', rest);
    window.addEventListener('resize', rest, { passive: true });
  }

  /* -------------------------------------------------- Botones magnéticos */
  function initMagnetic() {
    if (prefersReduced) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var clamp = function (v) { return Math.max(-8, Math.min(8, v)); };
    $$('.button:not(.button--block):not(.button--small)').forEach(function (el) {
      if (el.dataset.magneticBound) return;
      el.dataset.magneticBound = '1';
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var mx = clamp((e.clientX - (r.left + r.width / 2)) * 0.3);
        var my = clamp((e.clientY - (r.top + r.height / 2)) * 0.3);
        el.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* -------------------------------------------------- Overlay compartido */
  function getOverlay() {
    var ov = $('.overlay');
    if (!ov) {
      ov = document.createElement('div');
      ov.className = 'overlay';
      document.body.appendChild(ov);
    }
    return ov;
  }
  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  }

  /* -------------------------------------------------- Menú móvil */
  function initMobileMenu() {
    var menu = $('.mobile-menu');
    var openBtn = $('.header__burger');
    var closeBtn = $('.mobile-menu__close');
    if (!menu || !openBtn) return;
    var overlay = getOverlay();

    function open() {
      menu.classList.add('is-open');
      overlay.classList.add('is-active');
      menu.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      lockScroll(true);
      var firstLink = $('.mobile-menu__link', menu);
      if (firstLink) firstLink.focus({ preventScroll: true });
    }
    function close() {
      menu.classList.remove('is-open');
      overlay.classList.remove('is-active');
      menu.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      lockScroll(false);
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    $$('.mobile-menu__link', menu).forEach(function (l) { l.addEventListener('click', close); });
  }

  /* -------------------------------------------------- Buscador */
  function initSearch() {
    var panel = $('.search-panel');
    var toggles = $$('[data-search-toggle]');
    if (!panel || !toggles.length) return;
    var closeBtn = $('[data-search-close]', panel);
    function open() {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      var input = $('input[type="search"]', panel);
      if (input) setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    }
    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        panel.classList.contains('is-open') ? close() : open();
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* -------------------------------------------------- Acordeones */
  function initAccordions() {
    $$('.accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
      });
    });
  }

  /* -------------------------------------------------- Selectores de cantidad */
  function initQuantity(ctx) {
    $$('.quantity', ctx).forEach(function (q) {
      if (q.dataset.bound) return;
      q.dataset.bound = '1';
      var input = $('input', q);
      var minus = $('[data-qty="minus"]', q);
      var plus = $('[data-qty="plus"]', q);
      if (!input) return;
      function change(delta) {
        var val = parseInt(input.value, 10) || 1;
        val = Math.max(parseInt(input.min, 10) || 1, val + delta);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (minus) minus.addEventListener('click', function () { change(-1); });
      if (plus) plus.addEventListener('click', function () { change(1); });
    });
  }

  /* ==================================================================
     CARRITO
     ================================================================== */
  var Cart = {
    drawer: null,
    init: function () {
      this.drawer = $('[data-cart-drawer]');
      this.bindOpeners();
      this.bindQuickAdd();
      this.bindProductForms();
      // El carrito (cajón, contador y barra de envío) ya viene renderizado por
      // el servidor; solo enlazamos eventos. Se re-renderiza tras añadir/cambiar.
      if (this.drawer) this.bindDrawerEvents();
    },

    bindOpeners: function () {
      var self = this;
      $$('[data-cart-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (theme.cartType === 'drawer' && self.drawer) {
            e.preventDefault();
            self.open();
          }
        });
      });
    },

    bindDrawerEvents: function () {
      var self = this;
      var overlay = getOverlay();
      var closeBtn = $('[data-cart-close]', this.drawer);
      if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });
      overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });

      // Delegación: cambios de cantidad y eliminación
      this.drawer.addEventListener('click', function (e) {
        var remove = e.target.closest('[data-line-remove]');
        if (remove) {
          e.preventDefault();
          self.change(remove.dataset.lineRemove, 0);
        }
      });
      this.drawer.addEventListener('change', function (e) {
        var input = e.target.closest('[data-line-qty]');
        if (input) self.change(input.dataset.lineQty, parseInt(input.value, 10));
      });
    },

    open: function () {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      getOverlay().classList.add('is-active');
      lockScroll(true);
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      getOverlay().classList.remove('is-active');
      lockScroll(false);
    },

    refreshCountOnly: function () {
      fetch(theme.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.updateCount(cart.item_count); })
        .catch(function () {});
    },

    refresh: function () {
      var self = this;
      return fetch(theme.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },

    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-visible', count > 0);
        el.style.animation = 'none';
        void el.offsetWidth;
        if (count > 0 && !prefersReduced) el.style.animation = 'pop 0.4s var(--ease-out)';
      });
    },

    add: function (id, quantity) {
      var self = this;
      return fetch(theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      }).then(function () {
        return self.refresh();
      }).then(function (cart) {
        self.updateCount(cart.item_count);
        if (theme.cartType === 'drawer' && self.drawer) self.open();
        else showToast(theme.strings.addedToCart);
        return cart;
      });
    },

    change: function (line, quantity) {
      var self = this;
      return fetch(theme.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: line, quantity: quantity })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); self.updateCount(cart.item_count); return cart; });
    },

    bindQuickAdd: function () {
      var self = this;
      $$('[data-quick-add]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          var variant = btn.dataset.variantId;
          var url = btn.dataset.productUrl;
          if (!variant) { if (url) window.location.href = url; return; }
          e.preventDefault();
          btn.classList.add('is-loading');
          self.add(variant, 1)
            .catch(function () { showToast('No se pudo añadir. Inténtalo de nuevo.'); })
            .finally(function () { btn.classList.remove('is-loading'); });
        });
      });
    },

    bindProductForms: function () {
      var self = this;
      $$('form[action*="/cart/add"]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('[type="submit"]');
          var idInput = form.querySelector('[name="id"]');
          var qtyInput = form.querySelector('[name="quantity"]');
          if (!idInput || !idInput.value) return;
          if (btn) btn.classList.add('is-loading');
          self.add(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1)
            .catch(function () { showToast('No se pudo añadir. Inténtalo de nuevo.'); })
            .finally(function () { if (btn) btn.classList.remove('is-loading'); });
        });
      });
    },

    render: function (cart) {
      if (!this.drawer) return;
      var itemsEl = $('[data-cart-items]', this.drawer);
      var emptyEl = $('[data-cart-empty]', this.drawer);
      var footEl = $('[data-cart-foot]', this.drawer);
      var subtotalEl = $('[data-cart-subtotal]', this.drawer);

      if (cart.item_count === 0) {
        if (emptyEl) emptyEl.hidden = false;
        if (itemsEl) itemsEl.innerHTML = '';
        if (footEl) footEl.hidden = true;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (footEl) footEl.hidden = false;
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      if (itemsEl) {
        itemsEl.innerHTML = cart.items.map(function (item) {
          var img = item.image
            ? '<img src="' + item.image.replace(/(\.[^.]+)$/, '_160x$1') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="76" height="76">'
            : '';
          var variant = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<div class="line-item__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
          return '' +
            '<div class="line-item">' +
              '<a class="line-item__media" href="' + item.url + '">' + img + '</a>' +
              '<div class="line-item__details">' +
                '<a href="' + item.url + '"><div class="line-item__title">' + escapeHtml(item.product_title) + '</div></a>' +
                variant +
                '<div class="line-item__price">' + formatMoney(item.final_line_price) + '</div>' +
                '<div class="line-item__qty">' +
                  '<div class="quantity">' +
                    '<button type="button" data-qty="minus" aria-label="Disminuir cantidad">&minus;</button>' +
                    '<input type="number" value="' + item.quantity + '" min="0" data-line-qty="' + item.key + '" aria-label="Cantidad">' +
                    '<button type="button" data-qty="plus" aria-label="Aumentar cantidad">+</button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<button class="line-item__remove" data-line-remove="' + item.key + '" type="button">Quitar</button>' +
            '</div>';
        }).join('');
        initQuantity(itemsEl);
      }

      this.renderShippingBar(cart);
    },

    renderShippingBar: function (cart) {
      var bar = $('[data-shipping-bar]', this.drawer);
      if (!bar) return;
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold || threshold <= 0) { bar.hidden = true; return; }
      bar.hidden = false;
      var fill = $('[data-shipping-fill]', bar);
      var text = $('[data-shipping-text]', bar);
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      if (fill) fill.style.width = pct + '%';
      if (text) {
        if (cart.total_price >= threshold) {
          text.innerHTML = bar.dataset.qualified || '¡Tienes envío gratis! 🌿';
        } else {
          var remaining = formatMoney(threshold - cart.total_price);
          text.innerHTML = (bar.dataset.away || 'Te faltan {{amount}} para envío gratis').replace('{{amount}}', '<strong>' + remaining + '</strong>');
        }
      }
    }
  };

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizedImage(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 900);
  }

  /* ==================================================================
     VISTA RÁPIDA (Quick View)
     ================================================================== */
  var QuickView = {
    modal: null, current: null, selected: {},

    bind: function () {
      var self = this;
      $$('[data-quick-view]').forEach(function (btn) {
        if (btn.dataset.qvBound) return;
        btn.dataset.qvBound = '1';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (btn.dataset.productUrl) self.open(btn.dataset.productUrl);
        });
      });
    },

    build: function () {
      if (this.modal) return;
      var self = this;
      var el = document.createElement('div');
      el.className = 'quickview';
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML =
        '<div class="quickview__dialog" role="dialog" aria-modal="true" aria-label="Vista rápida">' +
          '<button class="quickview__close" data-qv-close aria-label="Cerrar">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>' +
          '</button>' +
          '<div class="quickview__body" data-qv-body></div>' +
        '</div>';
      document.body.appendChild(el);
      this.modal = el;
      $('[data-qv-close]', el).addEventListener('click', function () { self.close(); });
      el.addEventListener('click', function (e) { if (e.target === el) self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) self.close(); });
    },

    open: function (url) {
      var self = this;
      this.build();
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      var closeBtn = $('[data-qv-close]', this.modal);
      if (closeBtn) closeBtn.focus();
      $('[data-qv-body]', this.modal).innerHTML = '<div class="quickview__loading"><span class="spinner"></span></div>';
      fetch(url.split('?')[0] + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (product) { self.render(product); })
        .catch(function () { self.close(); window.location.href = url; });
    },

    close: function () {
      if (!this.modal) return;
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      // No desbloquear el scroll si el cajón del carrito quedó abierto (tras añadir)
      if (!(Cart.drawer && Cart.drawer.classList.contains('is-open'))) lockScroll(false);
    },

    render: function (product) {
      this.current = product;
      this.selected = {};
      var bodyEl = $('[data-qv-body]', this.modal);
      var imgUrl = product.featured_image || (product.images && product.images[0]) || '';

      var desc = '';
      if (product.description) {
        var tmp = document.createElement('div');
        tmp.innerHTML = product.description;
        desc = (tmp.textContent || '').trim();
        if (desc.length > 180) desc = desc.slice(0, 180).trim() + '…';
      }

      var optionsHtml = '';
      if (product.variants.length > 1 && product.options) {
        product.options.forEach(function (name, i) {
          var values = [];
          product.variants.forEach(function (v) {
            var val = v['option' + (i + 1)];
            if (val && values.indexOf(val) === -1) values.push(val);
          });
          optionsHtml += '<div class="qv-option" data-qv-option="' + (i + 1) + '">' +
            '<div class="qv-option__label">' + escapeHtml(name) + '</div>' +
            '<div class="qv-option__values">' +
              values.map(function (val) {
                return '<button type="button" class="variant-pill" data-qv-value="' + escapeHtml(val) + '">' + escapeHtml(val) + '</button>';
              }).join('') +
            '</div></div>';
        });
      }

      bodyEl.innerHTML =
        '<div class="quickview__media">' + (imgUrl ? '<img src="' + sizedImage(imgUrl, 900) + '" alt="' + escapeHtml(product.title) + '" data-qv-image>' : '') + '</div>' +
        '<div class="quickview__details">' +
          (product.vendor ? '<div class="product__vendor">' + escapeHtml(product.vendor) + '</div>' : '') +
          '<h2 class="quickview__title">' + escapeHtml(product.title) + '</h2>' +
          '<div class="quickview__price" data-qv-price></div>' +
          (desc ? '<p class="quickview__desc">' + escapeHtml(desc) + '</p>' : '') +
          optionsHtml +
          '<div class="quickview__buy">' +
            '<div class="quantity" data-qv-qty><button type="button" data-qty="minus" aria-label="Disminuir">&minus;</button><input type="number" value="1" min="1" aria-label="Cantidad"><button type="button" data-qty="plus" aria-label="Aumentar">+</button></div>' +
            '<button type="button" class="button button--block" data-qv-add></button>' +
          '</div>' +
          '<a href="' + product.url + '" class="link-underline quickview__more">' + (theme.strings.viewDetails || 'Ver detalles') + '</a>' +
        '</div>';

      initQuantity(bodyEl);

      var self = this;
      var firstAvail = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
      if (product.options && product.variants.length > 1) {
        product.options.forEach(function (name, i) { self.selected[i + 1] = firstAvail['option' + (i + 1)]; });
        $$('[data-qv-option]', bodyEl).forEach(function (group) {
          var idx = group.dataset.qvOption;
          $$('.variant-pill', group).forEach(function (pill) {
            pill.classList.toggle('is-active', pill.dataset.qvValue === self.selected[idx]);
            pill.addEventListener('click', function () {
              $$('.variant-pill', group).forEach(function (p) { p.classList.remove('is-active'); });
              pill.classList.add('is-active');
              self.selected[idx] = pill.dataset.qvValue;
              self.update();
            });
          });
        });
      }
      this.update();

      $('[data-qv-add]', bodyEl).addEventListener('click', function () {
        var v = self.matched();
        if (!v || !v.available) return;
        var qtyInput = $('[data-qv-qty] input', bodyEl);
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        var addBtn = this;
        addBtn.classList.add('is-loading');
        Cart.add(v.id, qty)
          .then(function () { self.close(); })
          .catch(function () { showToast('No se pudo añadir. Inténtalo de nuevo.'); })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      });
    },

    matched: function () {
      var self = this;
      if (!this.current) return null;
      if (this.current.variants.length === 1) return this.current.variants[0];
      return this.current.variants.filter(function (v) {
        return Object.keys(self.selected).every(function (k) { return v['option' + k] === self.selected[k]; });
      })[0];
    },

    update: function () {
      var bodyEl = $('[data-qv-body]', this.modal);
      var v = this.matched();
      var priceEl = $('[data-qv-price]', bodyEl);
      var addBtn = $('[data-qv-add]', bodyEl);
      var imgEl = $('[data-qv-image]', bodyEl);
      if (!v) {
        if (addBtn) { addBtn.textContent = theme.strings.soldOut; addBtn.disabled = true; }
        return;
      }
      if (priceEl) {
        var html = formatMoney(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html = '<span class="price__compare">' + formatMoney(v.compare_at_price) + '</span><span class="price__sale">' + formatMoney(v.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? theme.strings.addToCart : theme.strings.soldOut;
      }
      if (imgEl && v.featured_image && v.featured_image.src) {
        imgEl.src = sizedImage(v.featured_image.src, 900);
      }
    }
  };

  /* ==================================================================
     PÁGINA DE PRODUCTO: galería + variantes
     ================================================================== */
  function initProduct() {
    var root = $('[data-product]');
    if (!root) return;

    // Galería
    var mainImg = $('[data-product-main-image] img', root);
    $$('[data-product-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.dataset.full;
        if (mainImg && full) {
          if (!prefersReduced) { mainImg.style.opacity = '0'; }
          setTimeout(function () {
            mainImg.src = full;
            mainImg.style.opacity = '1';
          }, prefersReduced ? 0 : 160);
        }
        $$('[data-product-thumb]', root).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Variantes
    var variantData;
    try { variantData = JSON.parse($('[data-variant-json]', root).textContent); }
    catch (e) { variantData = null; }
    if (!variantData) return;

    var selected = {};
    var form = $('form[action*="/cart/add"]', root);
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var priceEl = $('[data-product-price]', root);
    var addBtn = form ? form.querySelector('[data-add-btn]') : null;

    $$('[data-option-index]', root).forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex, 10);
      var active = $('.variant-pill.is-active', group);
      if (active) selected[idx] = active.dataset.value;
      $$('.variant-pill', group).forEach(function (pill) {
        pill.addEventListener('click', function () {
          $$('.variant-pill', group).forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          selected[idx] = pill.dataset.value;
          var lbl = $('[data-option-value]', group);
          if (lbl) lbl.textContent = pill.dataset.value;
          updateVariant();
        });
      });
    });

    function updateVariant() {
      var match = variantData.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[i + 1] === undefined || selected[i + 1] === opt;
        });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = formatMoney(match.price);
        if (match.compare_at_price > match.price) {
          html = '<span class="price__compare">' + formatMoney(match.compare_at_price) + '</span><span class="price__sale">' + formatMoney(match.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        var label = $('.button__label', addBtn) || addBtn;
        if (match.available) { addBtn.disabled = false; label.textContent = theme.strings.addToCart; }
        else { addBtn.disabled = true; label.textContent = theme.strings.soldOut; }
      }
      // Cambia imagen principal a la de la variante si existe
      if (match.featured_image && mainImg) {
        mainImg.src = match.featured_image.src.replace(/(\.[^.?]+)(\?|$)/, '_800x$1$2');
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
    }
  }

  /* -------------------------------------------------- Sticky add-to-cart reveal */
  function initStickyBuy() {
    var bar = $('[data-sticky-buy]');
    var anchor = $('[data-product] .product__buy');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* -------------------------------------------------- Filas de colección (carrusel) */
  function initCollectionRows(ctx) {
    $$('[data-collection-row]', ctx).forEach(function (row) {
      if (row.dataset.rowBound) return;
      row.dataset.rowBound = '1';
      var track = $('[data-row-track]', row);
      if (!track) return;
      var arrows = $('[data-row-arrows]', row);
      var prev = $('[data-row-prev]', row);
      var next = $('[data-row-next]', row);
      function step() { return Math.max(track.clientWidth * 0.85, 240); }
      function update() {
        var scrollable = track.scrollWidth - track.clientWidth > 4;
        if (arrows) arrows.hidden = !scrollable;
        if (!scrollable) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* -------------------------------------------------- Init */
  function init() {
    initReveals();
    initHeader();
    initNavIndicator();
    initMagnetic();
    initMobileMenu();
    initSearch();
    initAccordions();
    initQuantity(document);
    Cart.init();
    QuickView.bind();
    initProduct();
    initStickyBuy();
    initCollectionRows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinit en el editor de temas de Shopify
  document.addEventListener('shopify:section:load', function () {
    initReveals(); initAccordions(); initQuantity(document); Cart.bindQuickAdd(); initProduct();
    initNavIndicator(); initMagnetic(); QuickView.bind(); initCollectionRows();
  });

  window.MiJardin = { Cart: Cart, showToast: showToast, formatMoney: formatMoney };
})();
